export default __webpack_public_path__ + "static/media/task.3f0810e1.svg";